import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { useContent } from "@/context/SiteContentContext";

const LegalPage = ({ title, contentKey, defaultBody }) => {
  const body = useContent(contentKey, defaultBody);
  return (
    <div className="app-shell">
      <Navbar />
      <main style={{ paddingTop: 120, paddingBottom: 80 }}>
        <div className="container-belle" style={{ maxWidth: 720 }}>
          <div className="overline" style={{ color: "var(--brand-accent)" }}>Le Salon</div>
          <h1
            className="editorial-h1"
            style={{ fontSize: "clamp(40px, 5.5vw, 64px)", marginTop: 12, marginBottom: 28 }}
          >
            {title}
          </h1>
          <div
            data-testid={`legal-body-${contentKey}`}
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 18,
              lineHeight: 1.7,
              color: "var(--text-primary)",
              whiteSpace: "pre-wrap",
            }}
          >
            {body}
          </div>
          <p className="overline" style={{ marginTop: 48, color: "var(--text-muted)" }}>
            Last updated · {new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export const Guidelines = () => (
  <LegalPage
    title="Community Guidelines"
    contentKey="legal.guidelines.body"
    defaultBody="Community Guidelines are being written."
  />
);

export const Terms = () => (
  <LegalPage
    title="Terms of Service"
    contentKey="legal.terms.body"
    defaultBody="Terms of Service will be posted before public launch."
  />
);

export const Privacy = () => (
  <LegalPage
    title="Privacy Policy"
    contentKey="legal.privacy.body"
    defaultBody="Privacy Policy will be posted before public launch."
  />
);
